/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useModalContext } from "../../../context/ModalContext";
import "./StateBlueprintRenderer.css";

import * as joint from "jointjs";
import { useNavigate, useParams } from "react-router-dom";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import Loader from "../../../Layouts/Loader/Loader";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import { mapArrayToObject } from "../../../commonFunctions/arrayFunc";
import { createChecksum } from "../../../commonFunctions/fileFolderConfig";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import NotesAndTags from "../../../components/BuilderComponents/NotesAndTags";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import Button from "../../../components/FormComponents/Button";
import ChipsInput from "../../../components/FormComponents/ChipsInput";
import Input from "../../../components/FormComponents/Input";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import { useAppOrgContext } from "../../../context/AppOrgContext";
import { useAuth0Context } from "../../../context/Auth0Context";
import { useFormContext } from "../../../context/FormContext";
import { useStatemachineContext } from "../../../context/StatemachineContext";
import { useTableContext } from "../../../context/TableContext";
import { setInitialAndModifiedChecksum } from "../../../utils/checksum";
import { FormLayoutWithEdit } from "../../Form/FormSection";
import RightSideFieldsBar from "../../Form/RightSideFieldsBar";
import OwnerAssignment from "../OwnerAssignment";
import ProCode from "../ProCode";
import { EditActityOption } from "./EditActityOption";
import { EditRememberOption } from "./EditRememberOption";
import LineStateActivityUpdate from "./LineStateActivityUpdate";
import SaveTemplate from "./SaveTemplate";
import {
  createAndRendererState,
  createAndRendererTransition,
  createAndRenderGateway,
  getCanvasHeightValue,
  getInsertConfig,
  getPaperclientWidthandclientHeight
} from "./StateBlueprintFunction";
import FieldTag from "../../Form/FieldTags/FieldTag";
import { getFieldIcon } from "../../../utils/getFieldIcon";
import JobConfigrationCopy from "../../../components/BuilderComponents/JobConfigration/JobConfigrationCopy";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { useTreeContext } from "../../../context/TreeDataContext";
import { toastError, toastSuccess } from "../../../utils/toastUtils";
import { getTreeDataForStateMachine } from "../../../utils/treeData/treeDataUtils";
import EditGatewayOption from "./EditGatewayOption";
// const namespace = joint.shapes;
const { dia, highlighters, linkTools, elementTools } = joint;
const unit = 4;
const spacing = 2 * unit;

// const fontAttributes = {
//   fontFamily: "PPFraktionSans, sans-serif",
//   fontStyle: "normal",
//   fontSize: 14,
//   lineHeight: 18
// };
const highlighterAttrs = {
  stroke: "#FF4365",
  "stroke-width": 2
};
const graph = new joint.dia.Graph();

// const flowSpacing = unit / 2;
// const rootEl = document.querySelector(':root');
// rootEl.style.setProperty('--flow-spacing', `${flowSpacing}px`);

let paper;
let statesObject = {}, // for actual data
  activitiesObject = {},
  gatewaysObject = {},
  statesDataArray = [], // for diagram
  transitionsDataArray = [],
  scalePoint = {},
  gatewayBlock = [],
  initBlock = [];
const buttonGroupStateChange = {};
let smChecksum = "";

let elementpointerclickflag = true;
let init_activity_id = [];

const StateBlueprintRenderer = ({ aiData = null, isAI = false }) => {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const initialModalState = {
    isOpen: false,
    type: "",
    name: "",
    stateId: "",
    actId: ""
  };
  const [modalState, setModalState] = useState(initialModalState);
  const [isEditModalOpen, setIsEditModalOpen] = useState("");
  const [selectedItemData, setSelectedItemData] = useState(null);
  const [selectedItemDataExtraData, setSelectedItemDataExtraData] = useState(null);
  const [selectedTab, setSelectedTab] = useState("Diagram"); //related blocks,  global data
  const [allJobs, setAllJobs] = useState([]);
  const { setStateMachineExplorerData } = useTreeContext();

  const { orgId, appId, smId } = useParams();

  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [gStateElements, setGStateElements] = useState({});
  const [ownerAssignment, setOwnerAssignment] = useState();
  const {
    selectedStateMachine,
    selectedStateMachineBlueprint,
    setSelectedStateMachineBlueprint,
    handleSaveStatemachine,
    allProCode,
    setAllProCode,
    smUniqueFields,
    setSmUniqueFields,
    setActivityData,
    activityData,
    getStatemachineConfig
  } = useStatemachineContext();
  const { lockData, setLockData } = useAppBlocksContext();
  const { setSaveLoader } = useModalContext();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const { currentChecksum } = useAppOrgContext();
  const { renderFieldsData, setRenderFieldsArray, renderFieldsArray } = useFormContext();
  const [showNotesModal, setShowNotesModal] = useState(false);
  const allFieldsObject = useRef({});
  const { getTableTypeData } = useTableContext();
  const { user } = useAuth0Context();
  const lockDataRef = useRef(null);

  const openModal = (type, name, stateId, actId) => setModalState({ isOpen: true, type, name, stateId, actId });
  const closeModal = () => setModalState(initialModalState);

  const fetchStateMachine = async () => {
    try {
      let data = aiData;
      setIsError(false);
      if (!data) {
        const response = await axiosInstance.get(`/state-machine/${smId}`);
        data = response.data.config;
        smChecksum = response.data.checksum;
        if (!isAI) {
          const { tableObject } = await getTableTypeData("statemachine", data.id);
          allFieldsObject.current = { ...tableObject };
        }
      }
      setOwnerAssignment(data.owner_assignment_rules);
      if (!data.global_data_form) {
        setRenderFieldsArray([]);
        renderFieldsData.current = {};
      } else {
        const allFields = data.global_data_form?.fields || [];
        const newRenderArray = allFields.map((field, i) => {
          renderFieldsData.current[field.id] = field;
          return {
            w: 12,
            h:
              field.type === "container" || field.type === "recordset" || field.type === "recordset-list"
                ? field.components.length + 1
                : 1,
            x: 0,
            y: i,
            i: field.id
          };
        });
        setRenderFieldsArray(newRenderArray);
      }
      setInitialAndModifiedChecksum(JSON.parse(JSON.stringify(data)));
      // setInitialAndModifiedChecksum(data);
      setAllProCode(data.pro_code || []);
      setSmUniqueFields(data.unique_fields || []);
      setSelectedStateMachineBlueprint(data);
      const newChecksum = createChecksum(data);
      currentChecksum.current = newChecksum;
    } catch (error) {
      handleApiError(error);
      setIsError(true);
    }
  };

  const createConfigRectangleAndLines = (sm) => {
    let stateBlockBlueprint = sm.diagram_config.stateBlock;
    let lineBlockBlueprint = sm.diagram_config.lineBlock;
    let gatewayBlockBlueprint = sm.diagram_config?.gatewayBlock || {};
    let initBlockBlueprint = sm.diagram_config?.initBlock || {};
    let statesBlueprint = sm.states;
    let gatewayBlueprint = sm?.gateways || [];
    // eslint-disable-next-line no-unused-vars
    let activitiesBlueprint = sm.activities;
    init_activity_id = [];
    initBlock = []; // Reset initBlock
    for (let index = 0; index < activitiesBlueprint.length; index++) {
      const element = activitiesBlueprint[index];
      if (element.type === "init") {
        init_activity_id.push(element.id);
        // Load stored init positions if they exist
        const initId = `init_${element.id}`;
        if (initBlockBlueprint[initId]) {
          initBlock.push({
            id: initId,
            activityId: element.id,
            x: initBlockBlueprint[initId].x,
            y: initBlockBlueprint[initId].y
          });
        }
      }
    }
    let newStatesDataArray = [];
    let newGatewayArray = [];

    // eslint-disable-next-line no-unused-vars
    let newTransitionsDataArray = [];
    for (let index = 0; index < statesBlueprint.length; index++) {
      let element = statesBlueprint[index];
      let object = {
        id: element.id,
        name: element.name,
        w: stateBlockBlueprint?.[element.id]?.w || 200,
        x: stateBlockBlueprint?.[element.id]?.x || 200,
        y: stateBlockBlueprint?.[element.id]?.y || getCanvasHeightValue(newStatesDataArray),
        activities: element.remember?.allow_activities || [],
        state_type: element.type
      };
      let allowState = element.remember?.allow_state_targets || [];
      for (let index = 0; index < allowState.length; index++) {
        const allow_state = element.remember.allow_state_targets[index];
        let transitionsIs = lineBlockBlueprint[`${element.id}.${allow_state}`];
        if (transitionsIs) {
          transitionsIs.activities = [];
          if (!transitionsIs.border_color) {
            transitionsIs.border_color = "black";
          }
          if (!transitionsIs.stroke_width) {
            transitionsIs.stroke_width = 2;
          }
          newTransitionsDataArray.push(transitionsIs);
        } else {
          const newTransition = {
            tid: `${element.id}.${allow_state}`,
            source: element.id,
            target: allow_state,
            activities: [],
            border_color: "black",
            anchors: {
              source: {
                name: "midSide"
              },
              target: {
                name: "midSide"
              }
            }
          };
          newTransitionsDataArray.push(newTransition);
        }
      }

      let allowGateways = element.remember?.allow_gateway_targets || [];
      for (let g = 0; g < allowGateways.length; g++) {
        const gatewayId = allowGateways[g];
        let transitionsIs = lineBlockBlueprint[`${element.id}.${gatewayId}`];
        if (transitionsIs) {
          transitionsIs.activities = [];
          if (!transitionsIs.border_color) {
            transitionsIs.border_color = "black";
          }
          if (!transitionsIs.stroke_width) {
            transitionsIs.stroke_width = 2;
          }
          newTransitionsDataArray.push(transitionsIs);
        } else {
          const newTransition = {
            tid: `${element.id}.${gatewayId}`,
            source: element.id,
            target: gatewayId,
            border_color: "black",
            anchors: {
              source: {
                name: "midSide"
              },
              target: {
                name: "midSide"
              }
            }
          };
          newTransitionsDataArray.push(newTransition);
        }
      }

      newStatesDataArray.push(object);
    }

    for (let index = 0; index < gatewayBlueprint.length; index++) {
      let element = gatewayBlueprint[index];
      let object = {
        id: element.id,
        name: element.name,
        w: gatewayBlockBlueprint?.[element.id]?.w || 100,
        h: gatewayBlockBlueprint?.[element.id]?.h || 100,
        x: gatewayBlockBlueprint?.[element.id]?.x || 200,
        y: gatewayBlockBlueprint?.[element.id]?.y || getCanvasHeightValue(newGatewayArray),
        type: element.type
      };

      // let allowState = element.allow_state_targets || [];
      // for (let index = 0; index < allowState.length; index++) {
      //   const allow_state = element.allow_state_targets[index];
      //   let transitionsIs = lineBlockBlueprint[`${element.id}.${allow_state}`];
      //   if (transitionsIs) {
      //     transitionsIs.activities = [];
      //     if (!transitionsIs.border_color) {
      //       transitionsIs.border_color = "black";
      //     }
      //     if (!transitionsIs.stroke_width) {
      //       transitionsIs.stroke_width = 2;
      //     }
      //     newTransitionsDataArray.push(transitionsIs);
      //   } else {
      //     const newTransition = {
      //       tid: `${element.id}.${allow_state}`,
      //       source: element.id,
      //       target: allow_state,
      //       activities: [],
      //       border_color: "black",
      //       anchors: {
      //         source: {
      //           name: "midSide"
      //         },
      //         target: {
      //           name: "midSide"
      //         }
      //       }
      //     };
      //     newTransitionsDataArray.push(newTransition);
      //   }
      // }

      if (element.logic_type === "procode" && element.procode_logic && element.procode_logic.state_label_mapping) {
        let procodeStateMappings = element.procode_logic.state_label_mapping || [];
        for (let index = 0; index < procodeStateMappings.length; index++) {
          const mapping = procodeStateMappings[index];
          const allow_state = mapping.state_id;
          if (!allow_state) continue;

          let transitionsIs = lineBlockBlueprint[`${element.id}.${allow_state}`];
          if (transitionsIs && transitionsIs.gateways.type === "procode") {
            if (!transitionsIs.gateways) {
              transitionsIs.gateways = [];
            }
            if (!transitionsIs.border_color) {
              transitionsIs.border_color = "black";
            }
            if (!transitionsIs.stroke_width) {
              transitionsIs.stroke_width = 2;
            }
            if (mapping.label) {
              transitionsIs.gateways.push({ id: mapping.label, name: mapping.label, type: "procode" });
            }
            newTransitionsDataArray.push(transitionsIs);
          } else {
            const newTransition = {
              tid: `${element.id}.${allow_state}`,
              source: element.id,
              target: allow_state,
              gateways: [],
              border_color: "black",
              anchors: {
                source: {
                  name: "midSide"
                },
                target: {
                  name: "midSide"
                }
              }
            };
            if (mapping.label) {
              newTransition.gateways.push({ id: mapping.label, name: mapping.label, type: "procode" });
            }
            newTransitionsDataArray.push(newTransition);
          }
        }
      } else if (element.logic_type === "") {
        let stateChangeLogic = element.state_change_logic || [];
        for (let index = 0; index < stateChangeLogic.length; index++) {
          const logic = stateChangeLogic[index];
          const allow_state = logic.state_id;
          if (!allow_state) continue;
          let transitionsIs = lineBlockBlueprint[`${element.id}.${allow_state}`];
          if (transitionsIs) {
            transitionsIs.gateways = [];
            if (!transitionsIs.border_color) {
              transitionsIs.border_color = "black";
            }
            if (!transitionsIs.stroke_width) {
              transitionsIs.stroke_width = 2;
            }
            if (logic.label) {
              transitionsIs.gateways.push({ id: logic.label, name: logic.label, type: "gateway_state" });
            }
            newTransitionsDataArray.push(transitionsIs);
          } else {
            const newTransition = {
              tid: `${element.id}.${allow_state}`,
              source: element.id,
              target: allow_state,
              gateways: [],
              border_color: "black",
              anchors: {
                source: {
                  name: "midSide"
                },
                target: {
                  name: "midSide"
                }
              }
            };
            if (logic.label) {
              newTransition.gateways.push({ id: logic.label, name: logic.label, type: "gateway_state" });
            }
            newTransitionsDataArray.push(newTransition);
          }
        }
      }
      newGatewayArray.push(object);
    }

    // Handle init activities - create transitions from init to target states or gateways
    for (let index = 0; index < activitiesBlueprint.length; index++) {
      const activity = activitiesBlueprint[index];

      // Only process init activities
      if (activity.type !== "init") continue;

      // Scan state_change_logic
      const stateChangeLogic = activity.state_change_logic || [];
      for (let i = 0; i < stateChangeLogic.length; i++) {
        const logic = stateChangeLogic[i];
        const targetStateId = logic.state_id;
        if (!targetStateId) continue;
        processInitTarget(activity, targetStateId);
      }

      // Scan gateway_change_logic
      const gatewayChangeLogic = activity.gateway_change_logic || [];
      for (let i = 0; i < gatewayChangeLogic.length; i++) {
        const logic = gatewayChangeLogic[i];
        const targetGatewayId = logic.gateway_id;
        if (!targetGatewayId) continue;
        processInitTarget(activity, targetGatewayId);
      }
    }

    function processInitTarget(activity, targetId) {
      const transitionId = `init_${activity.id}.${targetId}`;
      let transitionsIs = lineBlockBlueprint[transitionId];

      if (transitionsIs) {
        transitionsIs.activities = [{ id: activity.id, name: activity.name }];
        if (!transitionsIs.border_color) transitionsIs.border_color = "black";
        if (!transitionsIs.stroke_width) transitionsIs.stroke_width = 2;
        newTransitionsDataArray.push(transitionsIs);
      } else {
        const newTransition = {
          tid: transitionId,
          source: `init_${activity.id}`,
          target: targetId,
          activities: [{ id: activity.id, name: activity.name }],
          border_color: "black",
          stroke_width: 2,
          anchors: {
            source: { name: "midSide" },
            target: { name: "midSide" }
          }
        };
        newTransitionsDataArray.push(newTransition);
      }
    }

    for (const transitionId in lineBlockBlueprint) {
      if (transitionId.startsWith("init_")) {
        // Check if we've already added this transition
        const alreadyExists = newTransitionsDataArray.some((t) => t.tid === transitionId);
        if (!alreadyExists) {
          const transition = lineBlockBlueprint[transitionId];
          // Ensure required properties exist
          if (!transition.border_color) {
            transition.border_color = "black";
          }
          if (!transition.stroke_width) {
            transition.stroke_width = 2;
          }
          if (!transition.activities || transition.activities.length === 0) {
            const activityId = transition.source.replace("init_", "");
            const activityName = activitiesObject[activityId]?.name || "Init";
            transition.activities = [{ id: activityId, name: activityName }];
          }
          newTransitionsDataArray.push(transition);
        }
      }
    }

    // for (let index = 0; index < newTransitionsDataArray.length; index++) {
    //   const transitionsIs = newTransitionsDataArray[index];
    //   for (let i = 0; i < statesObject[transitionsIs.source].remember.allow_activities.length; i++) {
    //     const allowActivity = activitiesObject[statesObject[transitionsIs.source].remember.allow_activities[i]];
    //     if (!allowActivity?.state_change_logic) {
    //       continue;
    //     }
    //     for (let j = 0; j < allowActivity.state_change_logic.length; j++) {
    //       const stateId = allowActivity.state_change_logic[j].state_id;
    //       if (transitionsIs.target === stateId) {
    //         // transitionsIs.activities.push(allowActivity.name);
    //         transitionsIs.activities.push({ id: allowActivity.id, name: allowActivity.name });
    //       }
    //     }
    //     for (let j = 0; j < buttonGroupStateChange[allowActivity.id].length; j++) {
    //       const stateId = buttonGroupStateChange[allowActivity.id][j].state_id;
    //       if (transitionsIs.target === stateId) {
    //         // transitionsIs.activities.push(allowActivity.name);
    //         transitionsIs.activities.push({ id: allowActivity.id, name: allowActivity.name });
    //       }
    //     }
    //   }
    // }
    for (let index = 0; index < newTransitionsDataArray.length; index++) {
      const transitionsIs = newTransitionsDataArray[index];
      if (!transitionsIs?.source || !transitionsIs?.target) continue;

      const sourceState = statesObject[transitionsIs.source];
      const allowActivities = sourceState?.remember?.allow_activities;
      if (!Array.isArray(allowActivities)) continue;

      for (let i = 0; i < allowActivities.length; i++) {
        const activityId = allowActivities[i];
        const allowActivity = activitiesObject?.[activityId];
        const stateChangeLogic = allowActivity?.state_change_logic;
        const gateWayChangeLogic = allowActivity?.gateway_change_logic ? allowActivity?.gateway_change_logic : [];
        if (!Array.isArray(stateChangeLogic)) continue;

        // Ensure the activities array exists
        if (!Array.isArray(transitionsIs.activities)) {
          transitionsIs.activities = [];
        }

        // Match via state_change_logic
        for (let j = 0; j < stateChangeLogic.length; j++) {
          const logic = stateChangeLogic[j];
          if (logic?.state_id === transitionsIs.target) {
            transitionsIs.activities.push({ id: allowActivity.id, name: allowActivity.name });
          }
        }

        for (let j = 0; j < gateWayChangeLogic.length; j++) {
          const logic = gateWayChangeLogic[j];
          if (logic?.gateway_id === transitionsIs.target) {
            transitionsIs.activities.push({ id: allowActivity.id, name: allowActivity.name });
          }
        }

        // Match via buttonGroupStateChange
        const buttonStates = buttonGroupStateChange?.[allowActivity.id];
        if (!Array.isArray(buttonStates)) continue;

        for (let j = 0; j < buttonStates.length; j++) {
          const buttonState = buttonStates[j];
          if (buttonState?.state_id === transitionsIs.target) {
            transitionsIs.activities.push({ id: allowActivity.id, name: allowActivity.name });
          }
        }
      }
    }

    statesDataArray = newStatesDataArray;
    transitionsDataArray = newTransitionsDataArray;
    gatewayBlock = newGatewayArray;

    initFunction();
  };

  const createLock = async () => {
    const userinfo = `${user.first_name} (${user.email})`;
    const lock = {
      type: "statemachine",
      user_id: user.sub,
      user_info: userinfo,
      type_id: smId,
      type_name: selectedStateMachine.name
    };
    await axiosInstance.post(`/app/lock`, lock);
    return lock;
  };

  const getLockInformation = async () => {
    const { data } = await axiosInstance.get(`/app/lock/type/statemachine/typeid/${smId}`);
    return data;
  };

  const deleteLockInformation = async () => {
    await axiosInstance.delete(`/app/lock/${smId}`);
  };

  // const forcedeleteLockInformation = async () => {
  //   await axiosInstance.delete(`/app/fd/lock/${smId}`);
  // };

  const initialFetching = async () => {
    try {
      setIsLoading(true);
      const lock = await getLockInformation();
      if (lock) {
        setLockData(lock);
        if (lock.user_id === user.sub) {
          await fetchStateMachine();
          initializeVariables();
        }
      } else {
        const newLock = await createLock();
        setLockData(newLock);
        await fetchStateMachine();
        initializeVariables();
      }
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  const initializeVariables = () => {
    statesObject = {};
    activitiesObject = {};
    statesDataArray = [];
    transitionsDataArray = [];
    scalePoint = {};
    gatewayBlock = [];
  };

  useEffect(() => {
    if (!selectedStateMachineBlueprint || !selectedStateMachineBlueprint.owner_assignment_rules) return;
    if (selectedStateMachineBlueprint.owner_assignment_rules || ownerAssignment) {
      selectedStateMachineBlueprint.owner_assignment_rules = ownerAssignment;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerAssignment]);

  // NOTE: temp solution
  useEffect(() => {
    lockDataRef.current = lockData;
  }, [lockData]);
  useEffect(() => {
    initialFetching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return async () => {
      if (lockDataRef.current && lockDataRef.current.user_id === user.sub) {
        await deleteLockInformation();
      }
    };
  }, [smId, aiData]);

  useEffect(() => {
    const fetchAllTemplatesAndJobs = async () => {
      try {
        const { data: postJobData } = await axiosInstance.get(`/jobs/filter?places=post_activity`);
        const { data: preJobData } = await axiosInstance.get(`/jobs/filter?places=pre_activity`);
        const { data: preSubmissionJobData } = await axiosInstance.get(`/jobs/filter?places=pre_submission`);

        setAllJobs({
          post_activity: postJobData,
          pre_activity: preJobData,
          pre_submission: preSubmissionJobData
        });
      } catch (error) {
        handleApiError(error);
      }
    };
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedStateMachineBlueprint && !isLoading && selectedTab === "Diagram") {
      for (let index = 0; index < selectedStateMachineBlueprint.states.length; index++) {
        let element = selectedStateMachineBlueprint.states[index];
        statesObject[element.id] = element;
      }
      // button group state change logic
      for (let index = 0; index < selectedStateMachineBlueprint.activities.length; index++) {
        let element = selectedStateMachineBlueprint.activities[index];
        const ActivityButtonGroup = [];
        for (let sec of element.form.sections) {
          for (let fields of sec.fields || []) {
            if (!fields) {
              console.log("field not found", fields, element);
            }
            if (fields.type === "button-group") {
              for (let buttonValues of fields.data.values) {
                const obj = {
                  state_id: buttonValues.value,
                  condition: "true"
                };
                ActivityButtonGroup.push(obj);
              }
            }
          }
        }
        buttonGroupStateChange[selectedStateMachineBlueprint.activities[index].id] = ActivityButtonGroup;
        activitiesObject[element.id] = element;
      }

      for (let index = 0; index < selectedStateMachineBlueprint?.gateways?.length; index++) {
        let element = selectedStateMachineBlueprint?.gateways[index];
        gatewaysObject[element.id] = element;
      }

      if (!selectedStateMachineBlueprint?.diagram_config) {
        selectedStateMachineBlueprint.diagram_config = {
          stateBlock: {},
          lineBlock: {},
          gatewayBlock: [],
          scale: { sx: 1.0, sy: 1.0 }
        };
      }

      scalePoint = selectedStateMachineBlueprint.diagram_config?.scale || { sx: 1.0, sy: 1.0, h: 0, w: 0 };
      createConfigRectangleAndLines(selectedStateMachineBlueprint);

      return () => {
        const canvasOutBox = document.getElementById("diagramCanvasOutBox");
        if (canvasOutBox) {
          resizeObserver.unobserve(canvasOutBox);
        }
      };
    }
    //  else {
    // initFunction();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStateMachineBlueprint, selectedTab]);

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const canvasOutBox = entry.target;
      const canvasOverflowBox = canvasOutBox.querySelector("#diagramCanvasOverflow");
      const diagramCanvas = canvasOutBox.querySelector("#diagramCanvas");

      if (canvasOverflowBox && diagramCanvas && paper) {
        canvasOverflowBox.style.width = `${canvasOutBox.clientWidth}px`;
        canvasOverflowBox.style.height = `${canvasOutBox.clientHeight}px`;

        const canvasDataOutBox = getPaperclientWidthandclientHeight(statesDataArray);

        const newWidth = Math.max(canvasOutBox.clientWidth, canvasDataOutBox.width, scalePoint?.w || 0);
        const newHeight = Math.max(canvasOutBox.clientHeight, canvasDataOutBox.height, scalePoint?.h || 0);

        paper.setDimensions(newWidth, newHeight);

        diagramCanvas.style.width = `${newWidth}px`;
        diagramCanvas.style.height = `${newHeight}px`;
      }
    }
  });

  const initFunction = () => {
    let canvasOutBox = document.getElementById("diagramCanvasOutBox");
    let canvasOverflowBox = document.getElementById("diagramCanvasOverflow");
    let canvasDataOutBox = getPaperclientWidthandclientHeight(statesDataArray);
    if (!canvasOutBox || !canvasOverflowBox) {
      return;
    }
    // canvasOverflowBox.style.width = `100%`;
    // canvasOverflowBox.style.height = `100%`;
    canvasOverflowBox.style.width = `${canvasOutBox.clientWidth - 10}px`;
    canvasOverflowBox.style.height = `${canvasOutBox.clientHeight}px`;
    paper = new joint.dia.Paper({
      el: document.getElementById("diagramCanvas"),
      // width: "100%",
      // height: "100%",
      width: Math.max(canvasOutBox.clientWidth - 10, canvasDataOutBox.width, scalePoint?.w || 0),
      height: Math.max(canvasOutBox.clientHeight, canvasDataOutBox.height, scalePoint?.h || 0),
      model: graph,
      gridSize: 10,
      snapLabels: true,
      drawGrid: true,
      linkPinning: false,
      markAvailable: true,
      async: true,
      sorting: dia.Paper.sorting.APPROX,
      defaultConnectionPoint: {
        name: "boundary",
        args: {
          offset: spacing,
          extrapolate: true
        }
      },
      interactive: {
        linkMove: false,
        stopDelegation: false,
        addLinkFromMagnet: false
      },
      background: {
        color: "#fbfbfb"
      },
      defaultRouter: { name: "rightAngle", args: { margin: unit * 7 } },
      defaultConnector: {
        name: "straight",
        args: { cornerType: "line", cornerPreserveAspectRatio: true }
      }
    });
    paper.model.clear();

    paper.options.defaultAnchor = {
      name: "modelCenter",
      args: {
        rotate: true,
        padding: 2
      }
    };

    resizeObserver.observe(canvasOutBox);

    if (scalePoint) {
      paper.scale(scalePoint?.sx || 1, scalePoint?.sy || 1);
      let canvasPaper = document.getElementById("diagramCanvas");
      // canvasPaper.style.width = `100%`;
      // canvasPaper.style.height = `100%`;
      let canvasDataOutBox = getPaperclientWidthandclientHeight(statesDataArray);
      canvasPaper.style.width = `${Math.max(canvasOutBox.clientWidth - 70, canvasDataOutBox.width, scalePoint.w)}px`;
      canvasPaper.style.height = `${Math.max(canvasOutBox.clientHeight, canvasDataOutBox.height, scalePoint.h)}px`;
    }

    // Create states
    statesDataArray.forEach((state) => {
      if (state.state_type === "start") {
        state.init_activity_ids = init_activity_id;
      }
      const { stateElement, initElements } = createAndRendererState(
        state,
        joint,
        graph,
        dia,
        elementTools,
        paper,
        activitiesObject,
        initBlock
      );
      gStateElements[state.id] = stateElement;

      // Register init elements in gStateElements so they can be used as transition sources
      initElements.forEach(({ id, element }) => {
        gStateElements[id] = element;
      });
    });

    // Create gateways
    gatewayBlock.forEach((gateway) => {
      let gatewayElement = createAndRenderGateway(gateway, joint, graph, dia, elementTools, paper);
      gStateElements[gateway.id] = gatewayElement;
    });

    // Create transitions
    transitionsDataArray.forEach((transition) => {
      createAndRendererTransition(transition, gStateElements, graph, joint);
    });

    // eslint-disable-next-line no-unused-vars
    const { mask: MaskHighlighter, stroke: StrokeHighlighter } = highlighters;

    paper.on("link:pointerclick", (cellView) => {
      // paper.removeTools();
      dia.HighlighterView.removeAll(paper);
      const snapAnchor = function (coords, endView) {
        const bbox = endView.model.getBBox();
        // Find the closest point on the bbox border.
        const point = bbox.pointNearestToPoint(coords);
        const center = bbox.center();
        // Snap the point to the center of the bbox if it's close enough.
        const snapRadius = 10;
        if (Math.abs(point.x - center.x) < snapRadius) {
          point.x = center.x;
        }
        if (Math.abs(point.y - center.y) < snapRadius) {
          point.y = center.y;
        }
        return point;
      };
      const toolsView = new dia.ToolsView({
        tools: [
          new linkTools.TargetAnchor({
            snap: snapAnchor,
            resetAnchor: cellView.model.prop(["target", "anchor"])
          }),
          new linkTools.SourceAnchor({
            snap: snapAnchor,
            resetAnchor: cellView.model.prop(["source", "anchor"])
          })
        ]
      });
      toolsView.el.classList.add("jj-flow-tools");
      cellView.addTools(toolsView);
      joint.highlighters.mask.add(cellView, { selector: "line" }, "my-link-highlight", {
        // Draw the highlighter under the LinkView
        layer: "back",
        attrs: highlighterAttrs
      });
    });

    paper.on("blank:pointerdown", () => {
      // paper.removeTools();
      dia.HighlighterView.removeAll(paper);
    });

    paper.on("element:pointerclick", function (elementView) {
      const elType = elementView.model.attr("eltype");
      if (elType === "PAJobs") {
        const activityId = elementView.model.attr("activityid");
        if (activityId) {
          const data = activitiesObject[activityId];
          const config = {
            activity_owner_assignment: data.activity_owner_assignment,
            state_change_logic: data.state_change_logic || [],
            jobs_trigger: data.jobs_trigger || [],
            pre_activity_job: data.pre_activity_job || [],
            jobs_trigger_formula: data.jobs_trigger_formula || "",
            activity_change_logic: data.activity_change_logic || [],
            pre_submission: data.pre_submission || [],
            activity_response: data.activity_response || [],
            description: data.description || "",
            type: data.type || "default",
            sort_by: data.sort_by
          };
          setSelectedItemData(activitiesObject[activityId]);
          setActivityData(config);
          setIsEditModalOpen("jobs");
        }
      }
    });

    // paper.on("link:pointerdown", (linkView, evt) => {
    //   const linkModel = linkView.model;
    // });

    paper.on("link:pointerclick", (linkView) => {
      const linkModel = linkView.model;
      if (elementpointerclickflag) {
        let tid = linkModel.attributes.attrs.tid;
        for (let index = 0; index < transitionsDataArray.length; index++) {
          const element = transitionsDataArray[index];
          if (element.tid === tid) {
            setSelectedItemData(element);
            setIsEditModalOpen("transitions");
            break;
          }
        }

        elementpointerclickflag = false;
      } else {
        elementpointerclickflag = true;
      }
    });

    // Add an event listener for changes in element positions
    graph.on("change:position", (elementView, newPosition) => {
      const elType = elementView.attr("eltype");
      const stateId = elementView.attr("stateid");
      const x = newPosition.x;
      const y = newPosition.y;

      if (elType === "gateway") {
        const gatewayId = elementView.attr("gatewayId");
        for (let index = 0; index < gatewayBlock.length; index++) {
          let element = gatewayBlock[index];
          if (element.id === gatewayId) {
            gatewayBlock[index].x = x;
            gatewayBlock[index].y = y;
            break;
          }
        }
      } else if (elType === "init_activity") {
        // Track init round position changes
        const activityId = elementView.attr("activityid");
        const initId = `init_${activityId}`;

        // Find or create the init block entry
        let initBlockIndex = initBlock.findIndex((item) => item.id === initId);
        if (initBlockIndex === -1) {
          initBlock.push({ id: initId, activityId: activityId, x: x, y: y });
        } else {
          initBlock[initBlockIndex].x = x;
          initBlock[initBlockIndex].y = y;
        }
      } else {
        for (let index = 0; index < statesDataArray.length; index++) {
          let element = statesDataArray[index];
          if (element.id === stateId) {
            statesDataArray[index].x = x;
            statesDataArray[index].y = y;
            break;
          }
        }
      }

      let canvasPaper = document.getElementById("diagramCanvas");
      // canvasPaper.style.width = `100%`;
      // canvasPaper.style.height = `100%`;
      let canvasDataOutBox = getPaperclientWidthandclientHeight(statesDataArray);
      canvasPaper.style.width = `${Math.max(canvasOutBox.clientWidth - 70, canvasDataOutBox.width, scalePoint.w)}px`;
      canvasPaper.style.height = `${Math.max(canvasOutBox.clientHeight, canvasDataOutBox.height, scalePoint.h)}px`;
    });

    // Listen for the link:connect event to execute a function after the link is created
    paper.on("link:connect", function (linkView) {
      linkView.model.remove();
      // Get the model from the graph
      const sourceElementModel = graph.getCell(linkView.model.attributes.source.id);
      const targetElementModel = graph.getCell(linkView.model.attributes.target.id);
      const sourceType = sourceElementModel.attr("eltype");
      const targetType = targetElementModel.attr("eltype");
      if (targetType === "init_activity") {
        handleApiError({ response: { data: { message: "Incoming connections to Init are not allowed." } } });
        return;
      }

      if (sourceType === "init_activity") {
        const sourceInitId = sourceElementModel.id;
        const hasExistingConnection = transitionsDataArray.some((t) => t.source === sourceInitId);
        if (hasExistingConnection) {
          handleApiError({
            response: { data: { message: "Init activity can only have one outgoing connection." } }
          });
          return;
        }
      }

      if (sourceType === "state" && targetType === "state") {
        const sourceStateId = sourceElementModel.attr("stateid");
        const targetStateId = targetElementModel.attr("stateid");
        // Check if the transition already exists
        const newTransition = addAndRendererTransistion(sourceStateId, targetStateId);
        if (newTransition !== null) {
          // Transition doesn't exist, create it
          createAndRendererTransition(newTransition, gStateElements, graph, joint);

          for (let index = 0; index < selectedStateMachineBlueprint.states.length; index++) {
            const element = selectedStateMachineBlueprint.states[index];
            if (element.id === sourceStateId) {
              selectedStateMachineBlueprint.states[index].remember.allow_state_targets.push(targetStateId);
              break;
            }
          }
          addDiagramConfigInStateMachineObject();
          setSelectedStateMachineBlueprint({ ...selectedStateMachineBlueprint });
        } else {
          // Transition already exists, handle accordingly (e.g., show a message)
          handleApiError({ response: { data: { message: "Transition already exists." } } });
        }
      } else if (sourceType === "state" && targetType === "gateway") {
        const sourceStateId = sourceElementModel.attr("stateid");
        const targetGatewayId = targetElementModel.attr("gatewayId");
        const newTransition = addAndRendererTransistion(sourceStateId, targetGatewayId, [], "gateway");
        if (newTransition !== null) {
          createAndRendererTransition(newTransition, gStateElements, graph, joint);

          for (let index = 0; index < selectedStateMachineBlueprint.states.length; index++) {
            const element = selectedStateMachineBlueprint.states[index];
            if (element.id === sourceStateId) {
              if (!Array.isArray(selectedStateMachineBlueprint.states[index].remember.allow_gateway_targets)) {
                selectedStateMachineBlueprint.states[index].remember.allow_gateway_targets = [];
              }
              if (
                !selectedStateMachineBlueprint.states[index].remember.allow_gateway_targets.includes(targetGatewayId)
              ) {
                selectedStateMachineBlueprint.states[index].remember.allow_gateway_targets.push(targetGatewayId);
              }
              break;
            }
          }
          addDiagramConfigInStateMachineObject();
          setSelectedStateMachineBlueprint({ ...selectedStateMachineBlueprint });
        } else {
          handleApiError({ response: { data: { message: "Transition already exists." } } });
        }
      } else if (sourceType === "gateway" && targetType === "state") {
        const sourceGatewayId = sourceElementModel.attr("gatewayId");
        const targetStateId = targetElementModel.attr("stateid");
        const newTransition = addAndRendererTransistion(sourceGatewayId, targetStateId, [], "state");
        if (newTransition !== null) {
          createAndRendererTransition(newTransition, gStateElements, graph, joint);

          for (let index = 0; index < selectedStateMachineBlueprint.gateways.length; index++) {
            const element = selectedStateMachineBlueprint.gateways[index];
            if (element.id === sourceGatewayId) {
              if (!Array.isArray(selectedStateMachineBlueprint.gateways[index].allow_state_targets)) {
                selectedStateMachineBlueprint.gateways[index].allow_state_targets = [];
              }
              if (!selectedStateMachineBlueprint.gateways[index].allow_state_targets.includes(targetStateId)) {
                selectedStateMachineBlueprint.gateways[index].allow_state_targets.push(targetStateId);
              }
              if (!Array.isArray(selectedStateMachineBlueprint.gateways[index].state_change_logic)) {
                selectedStateMachineBlueprint.gateways[index].state_change_logic = [];
              }
              if (
                !selectedStateMachineBlueprint.gateways[index].state_change_logic.some(
                  (logic) => logic.state_id === targetStateId
                )
              ) {
                selectedStateMachineBlueprint.gateways[index].state_change_logic.push({
                  state_id: targetStateId,
                  condition: "true",
                  label: ""
                });
              }
              break;
            }
          }
          addDiagramConfigInStateMachineObject();
          setSelectedStateMachineBlueprint({ ...selectedStateMachineBlueprint });
        } else {
          handleApiError({ response: { data: { message: "Transition already exists." } } });
        }
      } else if (sourceType === "init_activity" && targetType === "gateway") {
        // Handle connection from init_activity to gateway
        const sourceInitId = sourceElementModel.id;
        const targetGatewayId = targetElementModel.attr("gatewayId");
        const activityIdForTrans = sourceInitId.replace("init_", "");
        const activityNameForTrans = activitiesObject[activityIdForTrans]?.name || "Init";
        const newTransition = addAndRendererTransistion(
          sourceInitId,
          targetGatewayId,
          [{ id: activityIdForTrans, name: activityNameForTrans }],
          "gateway"
        );
        if (newTransition !== null) {
          createAndRendererTransition(newTransition, gStateElements, graph, joint);

          const activityId = sourceInitId.replace("init_", "");
          for (let index = 0; index < selectedStateMachineBlueprint.activities.length; index++) {
            if (selectedStateMachineBlueprint.activities[index].id === activityId) {
              if (!Array.isArray(selectedStateMachineBlueprint.activities[index].gateway_change_logic)) {
                selectedStateMachineBlueprint.activities[index].gateway_change_logic = [];
              }
              if (
                !selectedStateMachineBlueprint.activities[index].gateway_change_logic.some(
                  (l) => l.gateway_id === targetGatewayId
                )
              ) {
                selectedStateMachineBlueprint.activities[index].gateway_change_logic.push({
                  gateway_id: targetGatewayId,
                  condition: "true"
                });
              }
              break;
            }
          }

          addDiagramConfigInStateMachineObject();
          setSelectedStateMachineBlueprint({ ...selectedStateMachineBlueprint });
        } else {
          handleApiError({ response: { data: { message: "Transition already exists." } } });
        }
      } else if (sourceType === "init_activity" && targetType === "state") {
        // Handle connection from init_activity to state
        const sourceInitId = sourceElementModel.id;
        const targetStateId = targetElementModel.attr("stateid");
        const activityIdForTrans = sourceInitId.replace("init_", "");
        const activityNameForTrans = activitiesObject[activityIdForTrans]?.name || "Init";
        const newTransition = addAndRendererTransistion(
          sourceInitId,
          targetStateId,
          [{ id: activityIdForTrans, name: activityNameForTrans }],
          "state"
        );
        if (newTransition !== null) {
          createAndRendererTransition(newTransition, gStateElements, graph, joint);

          const activityId = sourceInitId.replace("init_", "");
          for (let index = 0; index < selectedStateMachineBlueprint.activities.length; index++) {
            if (selectedStateMachineBlueprint.activities[index].id === activityId) {
              if (!Array.isArray(selectedStateMachineBlueprint.activities[index].state_change_logic)) {
                selectedStateMachineBlueprint.activities[index].state_change_logic = [];
              }
              if (
                !selectedStateMachineBlueprint.activities[index].state_change_logic.some(
                  (l) => l.state_id === targetStateId
                )
              ) {
                selectedStateMachineBlueprint.activities[index].state_change_logic.push({
                  state_id: targetStateId,
                  condition: "true"
                });
              }
              break;
            }
          }

          addDiagramConfigInStateMachineObject();
          setSelectedStateMachineBlueprint({ ...selectedStateMachineBlueprint });
        } else {
          handleApiError({ response: { data: { message: "Transition already exists." } } });
        }
      } else if (sourceType === "init_activity" && targetType === "activity") {
        handleApiError({ response: { data: { message: "Init can only connect to states or gateways." } } });
      }
    });

    // Add a click event to log the activity text
    paper.on("element:pointerclick", function (elementView) {
      // paper.removeTools();
      dia.HighlighterView.removeAll(paper);
      joint.highlighters.mask.add(elementView, { selector: "root" }, "my-element-highlight", {
        deep: true,
        attrs: highlighterAttrs
      });
      var elType = elementView.model.attr("eltype");
      if (elementpointerclickflag) {
        if (elType === "activity") {
          let activityId = elementView.model.attr("activityid");
          if (isAI) {
            openModal("show_form_preview", `${activitiesObject[activityId].name} Form`, null, activityId);
            return;
          }

          setSelectedItemData(activitiesObject[activityId]);
          setIsEditModalOpen("activity");
        } else if (elType === "state") {
          if (isAI) return;
          let stateId = elementView.model.attr("stateid");
          setSelectedItemData(statesObject[stateId]);
          for (let index = 0; index < statesDataArray.length; index++) {
            const element = statesDataArray[index];
            if (element.id === stateId) {
              setSelectedItemDataExtraData(element);
              break;
            }
          }
          setIsEditModalOpen("state");
        } else if (elType === "add_activity") {
          let stateId = elementView.model.attr("stateid");
          let stateName = elementView.model.attr("statename");
          openModal("add_activity_in_state", `Update Activity in ${stateName} State`, stateId);
        } else if (elType === "init_activity") {
          let activityId = elementView.model.attr("activityid");
          setSelectedItemData(activitiesObject[activityId]);
          setIsEditModalOpen("activity");
        } else if (elType === "gateway") {
          if (isAI) return;
          let gatewayId = elementView.model.attr("gatewayId");
          setSelectedItemData(gatewaysObject[gatewayId]);
          for (let index = 0; index < gatewayBlock.length; index++) {
            const element = gatewayBlock[index];
            if (element.id === gatewayId) {
              setSelectedItemDataExtraData(element);
              break;
            }
          }
          setIsEditModalOpen("gateway");
        }
        elementpointerclickflag = false;
      } else {
        elementpointerclickflag = true;
      }
    });
  };

  // Zoom In button click event
  function zoomInButton() {
    let canvasPaper = document.getElementById("diagramCanvas");
    canvasPaper.style.height = `${canvasPaper.clientHeight + 250}px`;
    canvasPaper.style.width = `${canvasPaper.clientWidth + 250}px`;

    scalePoint.sx = scalePoint.sx + 0.1;
    scalePoint.sy = scalePoint.sy + 0.1;
    paper.scale(scalePoint.sx, scalePoint.sy);
    scalePoint.h = canvasPaper.clientHeight + 250;
    scalePoint.w = canvasPaper.clientWidth + 250;
  }

  // Zoom Out button click event
  function zoomOutButton() {
    let canvasOverflowBox = document.getElementById("diagramCanvasOverflow");
    let canvasPaper = document.getElementById("diagramCanvas");
    canvasPaper.style.height = `${Math.max(canvasOverflowBox.clientHeight, canvasPaper.clientHeight - 250)}px`;
    canvasPaper.style.width = `${Math.max(canvasOverflowBox.clientWidth, canvasPaper.clientWidth - 250)}px`;

    scalePoint.sx = scalePoint.sx - 0.1;
    scalePoint.sy = scalePoint.sy - 0.1;
    paper.scale(scalePoint.sx, scalePoint.sy);
    scalePoint.h = Math.max(canvasOverflowBox.clientHeight, canvasPaper.clientHeight - 250);
    scalePoint.w = Math.max(canvasOverflowBox.clientWidth, canvasPaper.clientWidth - 250);
  }

  function moveCanvas(moveType) {
    // Get all links in the graph
    const links = graph.getLinks();
    const copySmData = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));

    let stateBlockBlueprint = {},
      lineBlockBlueprint = {};

    for (let index = 0; index < statesDataArray.length; index++) {
      const element = statesDataArray[index];
      if (moveType === "up") {
        if (element["state_type"] === "start") {
          if (element.activities.length !== 0) {
            //for length 1 and nothing for length 0
            element.y -= 10;
          }
        } else if (element.activities.length > 1) {
          //for lengt more than 1
          element.y -= 10;
        }
        element.y -= 10;
      } else if (moveType === "down") {
        element.y += 10;
        if (element["state_type"] === "start") {
          if (element.activities.length !== 0) {
            element.y -= 10;
          }
        } else if (element.activities.length > 1) {
          element.y -= 10;
        }
      } else if (moveType === "left") {
        if (element["state_type"] === "start") {
          if (element.activities.length !== 0) {
            element.y -= 10;
          }
        } else if (element.activities.length > 1) {
          element.y -= 10;
        }
        element.x -= 10;
      } else if (moveType === "right") {
        element.x += 10;
        if (element["state_type"] === "start") {
          if (element.activities.length !== 0) {
            element.y -= 10;
          }
        } else if (element.activities.length > 1) {
          element.y -= 10;
        }
      }
      stateBlockBlueprint[element.id] = element;
    }

    for (let index = 0; index < gatewayBlock.length; index++) {
      const element = gatewayBlock[index];
      if (moveType === "up") {
        element.y -= 10;
      } else if (moveType === "down") {
        element.y += 10;
      }
      gatewayBlock[index] = element;
    }

    for (let index = 0; index < transitionsDataArray.length; index++) {
      const element = transitionsDataArray[index];
      lineBlockBlueprint[element.tid] = element;
    }

    links.forEach((link) => {
      if (link.attributes.attrs.tid) {
        lineBlockBlueprint[link.attributes.attrs.tid]["anchors"] = {
          source: link.attributes.source.anchor,
          target: link.attributes.target.anchor
        };
      }
    });

    let gatewayBlockBlueprint = {};
    for (let index = 0; index < gatewayBlock.length; index++) {
      const element = gatewayBlock[index];
      gatewayBlockBlueprint[element.id] = element;
    }

    // Convert initBlock array to object format for storage
    let initBlockBlueprint = {};
    for (let index = 0; index < initBlock.length; index++) {
      const element = initBlock[index];
      initBlockBlueprint[element.id] = {
        activityId: element.activityId,
        x: element.x,
        y: element.y
      };
    }

    copySmData.diagram_config.stateBlock = stateBlockBlueprint;
    copySmData.diagram_config.lineBlock = lineBlockBlueprint;
    copySmData.diagram_config.gatewayBlock = gatewayBlockBlueprint;
    copySmData.diagram_config.initBlock = initBlockBlueprint;
    copySmData.diagram_config.scale = scalePoint;
    setSelectedStateMachineBlueprint(copySmData);
  }

  function addAndRendererTransistion(srcStateId, targetStateId, activities = [], type = "state") {
    // Check if a transition from source to target already exists
    const existingTransition = transitionsDataArray.find(
      (transition) => transition.source === srcStateId && transition.target === targetStateId
    );
    if (existingTransition) {
      return null;
    }
    var defaultAnchors = {
      source: {
        name: "midSide"
      },
      target: {
        name: "midSide"
      }
    };
    if (srcStateId === targetStateId) defaultAnchors.target.name = "topRight";
    // If the transition doesn't exist, add a new one
    const newTransition = {
      tid: `${srcStateId}.${targetStateId}`,
      source: srcStateId,
      target: targetStateId,
      activities: activities,
      anchors: defaultAnchors,
      type: type,
      border_color: "black",
      stroke_width: 2
    };
    transitionsDataArray.push(newTransition);
    return newTransition;
  }

  const cteateNewItemInStateMachine = async (data) => {
    const { type, stateId } = modalState;
    if (type === "add_activity_in_state") {
      const actIds = data.activities.map((item) => item["id"]);
      const newActivitiesConfig = data.activitiesNames.map((name) => {
        const { config } = getInsertConfig("activity", name);
        actIds.push(config.id);
        return config;
      });

      const newStates = selectedStateMachineBlueprint.states.map((state) => {
        if (state.id === stateId) {
          return {
            ...state,
            remember: {
              ...state.remember,
              allow_activities: actIds
            }
          };
        }
        return state;
      });
      setSelectedStateMachineBlueprint({
        ...selectedStateMachineBlueprint,
        activities: [...selectedStateMachineBlueprint.activities, ...newActivitiesConfig],
        states: newStates
      });
      closeModal();
      return;
    }
    addDiagramConfigInStateMachineObject();
    const { config, endpoint } = getInsertConfig(type, data);

    setSelectedStateMachineBlueprint({
      ...selectedStateMachineBlueprint,
      [endpoint]: [...(selectedStateMachineBlueprint[endpoint] || []), config]
    });
    closeModal();
  };

  const addDiagramConfigInStateMachineObject = () => {
    const links = graph.getLinks();

    let stateBlockBlueprint = {},
      lineBlockBlueprint = {},
      gatewayBlockBlueprint = {};

    for (let index = 0; index < statesDataArray.length; index++) {
      const element = statesDataArray[index];
      stateBlockBlueprint[element.id] = element;
      if (Object.keys(selectedItemDataExtraData || {}).length > 0 && "state" === isEditModalOpen) {
        if (element.id === selectedItemDataExtraData.id) {
          stateBlockBlueprint[element.id] = selectedItemDataExtraData;
        }
      }
    }

    for (let index = 0; index < transitionsDataArray.length; index++) {
      const element = transitionsDataArray[index];
      lineBlockBlueprint[element.tid] = element;
    }

    for (let index = 0; index < gatewayBlock.length; index++) {
      const element = gatewayBlock[index];
      gatewayBlockBlueprint[element.id] = element;
      if (Object.keys(selectedItemDataExtraData || {}).length > 0 && "gateway" === isEditModalOpen) {
        if (element.id === selectedItemDataExtraData.id) {
          gatewayBlockBlueprint[element.id] = selectedItemDataExtraData;
        }
      }
    }

    links.forEach((link) => {
      if (link.attributes.attrs.tid) {
        lineBlockBlueprint[link.attributes.attrs.tid]["anchors"] = {
          source: link.attributes.source.anchor,
          target: link.attributes.target.anchor
        };
      }
    });

    // Convert initBlock array to object format for storage
    let initBlockBlueprint = {};
    for (let index = 0; index < initBlock.length; index++) {
      const element = initBlock[index];
      initBlockBlueprint[element.id] = {
        activityId: element.activityId,
        x: element.x,
        y: element.y
      };
    }

    selectedStateMachineBlueprint.diagram_config.stateBlock = stateBlockBlueprint;
    selectedStateMachineBlueprint.diagram_config.lineBlock = lineBlockBlueprint;
    selectedStateMachineBlueprint.diagram_config.scale = scalePoint;
    selectedStateMachineBlueprint.diagram_config.gatewayBlock = gatewayBlockBlueprint;
    selectedStateMachineBlueprint.diagram_config.initBlock = initBlockBlueprint;
  };

  const saveStateMachineNewBlueprint = async (isAiSave = false) => {
    try {
      // if (lockData) {
      //   if (lockData.user_id !== user.sub) {
      //     toast.error("Unauthorized");
      //     return;
      //   }
      // }
      addDiagramConfigInStateMachineObject();

      setSaveLoader(true);
      const config = getStatemachineConfig();
      const { message, data } = await handleSaveStatemachine({ options: { checksum: smChecksum } });
      smChecksum = data?.checksum || "";
      if (isAiSave) {
        setStateMachineExplorerData(null);
      } else {
        const data = getTreeDataForStateMachine("single", config);
        setStateMachineExplorerData((pre) => {
          return pre.map((s) => {
            if (s.id === data.id) {
              return data;
            }
            return s;
          });
        });
      }
      // setSelectedStateMachineBlueprint((state) => {
      //   return { ...state };
      // });
      return { message };
    } catch (error) {
      handleApiError(error);
    } finally {
      setSaveLoader(false);
    }
  };
  const onClickFunctionHidePopup = () => {
    setIsEditModalOpen("");
    setSelectedItemData();
    setSelectedItemDataExtraData();
  };

  // const handleTakeOverLock = async () => {
  //   // delete existing lock
  //   try {
  //     setIsLoading(true);
  //     await forcedeleteLockInformation();
  //     const newLock = await createLock();
  //     setLockData(newLock);
  //     await fetchStateMachine();
  //     initializeVariables();
  //     setIsLoading(false);
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };

  const handleDelete = () => {
    addDiagramConfigInStateMachineObject();
    let id = selectedItemData.id;
    let objectIs;
    if ("activity" === isEditModalOpen) {
      objectIs = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));

      for (let index = 0; index < objectIs.activities.length; index++) {
        const element = objectIs.activities[index];
        if (element.id === id) {
          objectIs.activities.splice(index, 1);
          break;
        }
      }

      for (let index = 0; index < objectIs.states.length; index++) {
        const element = objectIs.states[index].remember;
        for (let i = 0; i < element.allow_activities.length; i++) {
          const ele = element.allow_activities[i];
          if (ele === id) {
            element.allow_activities.splice(i, 1);
            break;
          }
        }
        for (let i = 0; i < element.deny_activities.length; i++) {
          const ele = element.deny_activities[i];
          if (ele === id) {
            element.deny_activities.splice(i, 1);
            break;
          }
        }
        for (let i = 0; i < element.source_activity.length; i++) {
          const ele = element.source_activity[i];
          if (ele === id) {
            element.source_activity.splice(i, 1);
            break;
          }
        }
      }
      toastSuccess("Activity Deleted Successfully");
    } else if ("state" === isEditModalOpen) {
      objectIs = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));

      for (let index = 0; index < objectIs.states.length; index++) {
        const element = objectIs.states[index];
        if (element.id === id) {
          objectIs.states.splice(index, 1);
          break;
        }
      }

      for (let index = 0; index < objectIs.states.length; index++) {
        const element = objectIs.states[index].remember;
        for (let i = 0; i < element.allow_state_targets.length; i++) {
          const ele = element.allow_state_targets[i];
          if (ele === id) {
            element.allow_state_targets.splice(i, 1);
            break;
          }
        }
        for (let i = 0; i < element.deny_states_targets.length; i++) {
          const ele = element.deny_states_targets[i];
          if (ele === id) {
            element.deny_states_targets.splice(i, 1);
            break;
          }
        }
        for (let i = 0; i < element.allow_state_sources.length; i++) {
          const ele = element.allow_state_sources[i];
          if (ele === id) {
            element.allow_state_sources.splice(i, 1);
            break;
          }
        }
        for (let i = 0; i < element.deny_states_sources.length; i++) {
          const ele = element.deny_states_sources[i];
          if (ele === id) {
            element.deny_states_sources.splice(i, 1);
            break;
          }
        }
      }

      for (let index = 0; index < objectIs.activities.length; index++) {
        const element = objectIs.activities[index];
        for (let i = 0; i < element.state_change_logic.length; i++) {
          const ele = element.state_change_logic[i];
          if (ele.state_id === id) {
            element.state_change_logic.splice(i, 1);
            break;
          }
        }
      }
      toastSuccess("State Deleted Successfully");
    } else if ("gateway" === isEditModalOpen) {
      objectIs = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));

      for (let index = 0; index < objectIs.gateways.length; index++) {
        const element = objectIs.gateways[index];
        if (element.id === id) {
          objectIs.gateways.splice(index, 1);
          break;
        }
      }

      for (let index = 0; index < objectIs.states.length; index++) {
        const element = objectIs.states[index].remember;
        const targets = element?.allow_gateway_targets;
        if (Array.isArray(targets)) {
          for (let i = 0; i < targets.length; i++) {
            if (targets[i] === id) {
              targets.splice(i, 1);
              break;
            }
          }
        }
      }

      const lineBlock = objectIs.diagram_config.lineBlock;
      for (const key in lineBlock) {
        if (lineBlock[key].source === id || lineBlock[key].target === id) {
          delete lineBlock[key];
        }
      }

      const gatewayBlock = objectIs.diagram_config.gatewayBlock;
      for (const key in gatewayBlock) {
        if (gatewayBlock[key].id === id) {
          delete gatewayBlock[key];
        }
      }

      for (let index = 0; index < objectIs.activities.length; index++) {
        const element = objectIs.activities[index];
        for (let i = 0; i < element?.gateway_change_logic?.length; i++) {
          const ele = element.gateway_change_logic[i];
          if (ele.gateway_id === id) {
            element.gateway_change_logic.splice(i, 1);
            break;
          }
        }
      }

      toastSuccess("Gateway Deleted Successfully");
    }

    setSelectedStateMachineBlueprint({ ...objectIs });
    onClickFunctionHidePopup();
  };

  const onClickFunctionUpdateSM = () => {
    addDiagramConfigInStateMachineObject();
    let id = selectedItemData.id;

    let objectIs = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));
    if ("activity" === isEditModalOpen) {
      const copySelectedData = JSON.parse(JSON.stringify(selectedItemData));
      if (Array.isArray(selectedItemData.state_change_logic)) {
        copySelectedData.state_change_logic = copySelectedData.state_change_logic.filter((item) => item.state_id);
      }
      setSelectedItemData(copySelectedData);

      for (let index = 0; index < objectIs.activities.length; index++) {
        const element = objectIs.activities[index];
        if (element.id === id) {
          objectIs.activities[index] = copySelectedData;
          break;
        }
      }
    } else if ("state" === isEditModalOpen) {
      for (let index = 0; index < objectIs.states.length; index++) {
        const element = objectIs.states[index];
        if (element.id === id) {
          objectIs.states[index] = selectedItemData;
          break;
        }
      }
    } else if ("gateway" === isEditModalOpen) {
      for (let index = 0; index < objectIs.gateways.length; index++) {
        const element = objectIs.gateways[index];
        if (element.id === id) {
          objectIs.gateways[index] = selectedItemData;
          break;
        }
      }
      for (let index = 0; index < gatewayBlock.length; index++) {
        const element = gatewayBlock[index];
        if (element.id === id) {
          gatewayBlock[index] = selectedItemDataExtraData;
          break;
        }
      }
    } else if ("transitions" === isEditModalOpen) {
      objectIs["diagram_config"]["lineBlock"][selectedItemData.tid]["border_color"] = selectedItemData.border_color;
      objectIs["diagram_config"]["lineBlock"][selectedItemData.tid]["stroke_width"] = selectedItemData.stroke_width;
    }
    setSelectedStateMachineBlueprint({ ...objectIs });
    onClickFunctionHidePopup();
  };

  const removeTransitionLine = () => {
    const copyBluePrint = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));
    const { source, target } = selectedItemData;
    const stateObjIndex = copyBluePrint.states.findIndex((obj) => obj.id === source);
    const stateObj = copyBluePrint.states[stateObjIndex];
    if (stateObj) {
      const stateRememberData = stateObj?.remember;
      stateRememberData.allow_state_targets = stateRememberData.allow_state_targets.filter(
        (id) => id !== selectedItemData.target
      );
      stateRememberData.allow_gateway_targets = (stateRememberData.allow_gateway_targets || []).filter(
        (id) => id !== target
      );
      stateObj.remember = stateRememberData;
    }
    copyBluePrint.states[stateObjIndex] = stateObj;

    copyBluePrint.gateways = Array.isArray(copyBluePrint.gateways) ? copyBluePrint.gateways : [];

    // if source id is gateway and target id is state remove the states from state_change_logic and allow_state_targets
    const gatewayObjIndex = copyBluePrint.gateways.findIndex((obj) => obj.id === source);
    const stateObjTargetIndex = copyBluePrint.states.findIndex((obj) => obj.id === target);
    if (gatewayObjIndex !== -1 && stateObjTargetIndex !== -1) {
      const gatewayObj = copyBluePrint.gateways[gatewayObjIndex];
      if (gatewayObj) {
        gatewayObj.allow_state_targets = gatewayObj.allow_state_targets.filter((id) => id !== target);
        gatewayObj.state_change_logic = gatewayObj.state_change_logic.filter((logic) => logic.state_id !== target);
      }
      copyBluePrint.gateways[gatewayObjIndex] = gatewayObj;
    }

    // if source id is state and target id is gateway go to stateObj -remember.allow_activites. go throught all those activities
    // if those activities contain gateway_change_logic and the gateway of target id  remove that
    const stateObjSourceIndex = copyBluePrint.states.findIndex((obj) => obj.id === source);
    const gatewayObjTargetIndex = copyBluePrint.gateways.findIndex((obj) => obj.id === target);
    if (stateObjSourceIndex !== -1 && gatewayObjTargetIndex !== -1) {
      const stateObjSource = copyBluePrint.states[stateObjSourceIndex];
      if (stateObjSource) {
        // get all allow_activities in remember
        const allowActivities = stateObjSource.remember.allow_activities;
        for (let i = 0; i < allowActivities.length; i++) {
          const activity = allowActivities[i];
          const activityObj = copyBluePrint.activities.find((obj) => obj.id === activity);
          const activityIndex = copyBluePrint.activities.findIndex((obj) => obj.id === activity);
          if (activityObj) {
            const activityObjGatewayChangeLogic = activityObj?.gateway_change_logic;
            if (Array.isArray(activityObjGatewayChangeLogic)) {
              // loop through all the gateway_change_logic if gateway_change_logic.gateway_id === target, delete that
              for (let j = 0; j < activityObjGatewayChangeLogic.length; j++) {
                const gatewayChangeLogic = activityObjGatewayChangeLogic[j];
                if (gatewayChangeLogic.gateway_id === target) {
                  activityObjGatewayChangeLogic.splice(j, 1);
                  break;
                }
              }
              activityObj.gateway_change_logic = activityObjGatewayChangeLogic;
              copyBluePrint.activities[activityIndex] = activityObj;
            }
          }
        }
      }
      copyBluePrint.states[stateObjSourceIndex] = stateObjSource;
    }

    if (source && source.startsWith("init_")) {
      const activityId = source.replace("init_", "");
      const activityObjIndex = copyBluePrint.activities.findIndex((obj) => obj.id === activityId);
      if (activityObjIndex !== -1) {
        const activityObj = copyBluePrint.activities[activityObjIndex];
        // remove from state_change_logic
        activityObj.state_change_logic = (activityObj.state_change_logic || []).filter((l) => l.state_id !== target);
        // remove from gateway_change_logic
        activityObj.gateway_change_logic = (activityObj.gateway_change_logic || []).filter(
          (l) => l.gateway_id !== target
        );
        // remove from activity_change_logic
        activityObj.activity_change_logic = (activityObj.activity_change_logic || []).filter(
          (l) => l.activity_id !== target
        );

        copyBluePrint.activities[activityObjIndex] = activityObj;
      }

      // delete from diagram_config.lineBlock
      if (copyBluePrint.diagram_config.lineBlock && copyBluePrint.diagram_config.lineBlock[selectedItemData.tid]) {
        delete copyBluePrint.diagram_config.lineBlock[selectedItemData.tid];
      }
    }

    setSelectedStateMachineBlueprint(copyBluePrint);
    onClickFunctionHidePopup();
  };

  const removeTransitionFromGateway = (stateId) => {
    const copyBluePrint = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));
    const gatewayObjIndex = copyBluePrint.gateways.findIndex((obj) => obj.id === selectedItemData.id);
    if (gatewayObjIndex === -1) return;

    const gatewayObj = copyBluePrint.gateways[gatewayObjIndex];
    if (gatewayObj) {
      gatewayObj.allow_state_targets = gatewayObj.allow_state_targets.filter((id) => id !== stateId);
      gatewayObj.state_change_logic = gatewayObj.state_change_logic.filter((logic) => logic.state_id !== stateId);
    }
    setSelectedStateMachineBlueprint(copyBluePrint);
    onClickFunctionHidePopup();
  };

  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(selectedStateMachineBlueprint));
    copyBlockData[keyName] = data;
    setSelectedStateMachineBlueprint(copyBlockData);
  };
  if (isLoading) return <Loader />;
  if (isError) return <h1>Something went wrong</h1>;
  if (lockData && lockData.user_id !== user.sub) {
    return (
      <div className="h_100 d_flex justify_center align_center flex_column gap_3">
        <span>
          <strong>{lockData.user_info}</strong> is using the state machine.
        </span>
        {/* <Button onClick={handleTakeOverLock}>Yes</Button> */}
      </div>
    );
  }
  const tabData = [
    {
      label: "Diagram",
      content: (
        <div id="diagramCanvasOutBox" className="sm_blueprint_renderer_box diagramCanvasOutBox page_main_section p_0">
          {!isAI && (
            <div
              className="ai_bot_icon"
              style={{ left: "40px" }}
              onClick={() => navigate(`/organization/${orgId}/app/${appId}/statemachine/${smId}/ai`)}
            >
              <MaterialIcon name="smart_toy" />
            </div>
          )}
          <div className="sm_diagram_function_tabs">
            {!isAI && (
              <div className="sm_blueprint_functionboxOut">
                <MaterialIcon name="schema" onClick={() => openModal("state", "Create State")} title="Add State" />
                <hr></hr>
                <MaterialIcon
                  name="activity_zone"
                  onClick={() => openModal("activity", "Create Activity")}
                  title="Add Activity"
                />
                <hr></hr>
                <MaterialIcon
                  name="call_split"
                  onClick={() => openModal("gateway", "Create Gateway")}
                  title="Add Gateway"
                />
              </div>
            )}

            <div className="sm_blueprint_functionboxOut">
              <MaterialIcon name="zoom_in" title="zoom in" onClick={zoomInButton} />
              <hr></hr>
              <MaterialIcon name="zoom_out" title="zoom out" onClick={zoomOutButton} />
              <hr></hr>
              <MaterialIcon name="arrow_upward" title="move up" onClick={() => moveCanvas("up")} />
              <hr></hr>
              <MaterialIcon name="arrow_downward" title="move down" onClick={() => moveCanvas("down")} />
              <hr></hr>
              <MaterialIcon
                name="refresh"
                title="Refresh"
                onClick={() => {
                  fetchStateMachine();
                  statesObject = {};
                  activitiesObject = {};
                  statesDataArray = [];
                  transitionsDataArray = [];
                  scalePoint = {};
                  setIsEditModalOpen(false);
                }}
              />
              <DownloadFieldsDetails smId={smId} />
            </div>
          </div>

          <div id="diagramCanvasOverflow" className="diagramCanvasOverflow">
            <div id="diagramCanvas"></div>
          </div>
          <div
            className="sidebarView_edit_outer edit_open"
            style={{
              display: ["state", "activity", "owner", "transitions", "setting", "jobs", "gateway"].includes(
                isEditModalOpen
              )
                ? "block"
                : "none"
            }}
          >
            {isEditModalOpen === "transitions" && (
              <div>
                <div className="sidebar_top_header">
                  <p>Edit Transitions</p>
                  <MaterialIcon name="close" className="section_close_darkIcon" onClick={onClickFunctionHidePopup} />
                </div>
              </div>
            )}
            {isEditModalOpen === "transitions" && (
              <div>
                <div className="sm_blueprint_editBox edit_screen_fields">
                  <div className="rightPanel_inside_container">
                    <div className="form_element_wrapper_text mb_2">
                      <p className="builder_label">Line color</p>
                      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                        {["#454545", "red", "blue", "green"].map((color) => {
                          const isSelected = selectedItemData.border_color === color;

                          let wrapperStyle = {
                            padding: "4px",
                            borderRadius: "50%",
                            backgroundColor: isSelected ? "#c9c5c5" : "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer"
                          };

                          let circleStyle = {
                            height: isSelected ? "28px" : "24px",
                            width: isSelected ? "28px" : "24px",
                            backgroundColor: color,
                            borderRadius: "50%",
                            boxSizing: "border-box",
                            transition: "all 0.2s ease"
                          };

                          return (
                            <div
                              key={color}
                              style={wrapperStyle}
                              onClick={() => {
                                setSelectedItemData({ ...selectedItemData, border_color: color });
                              }}
                            >
                              <div style={circleStyle}></div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="form_element_wrapper_text mb_2">
                      <p className="builder_label">Line width</p>
                      <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                        <input
                          type="checkbox"
                          checked={selectedItemData.stroke_width === 4}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setSelectedItemData({
                              ...selectedItemData,
                              stroke_width: isChecked ? 4 : 2
                            });
                          }}
                        />
                        Thick
                      </label>
                    </div>
                    <LineStateActivityUpdate
                      item={selectedItemData}
                      setItem={setSelectedItemData}
                      selectedStateMachineBlueprint={selectedStateMachineBlueprint}
                      setSelectedStateMachineBlueprint={setSelectedStateMachineBlueprint}
                      activitiesObject={activitiesObject}
                      statesObject={statesObject}
                    />
                  </div>
                </div>

                <div className="save_block down" style={{ padding: "0px 20px" }}>
                  <Button variant="delete" onClick={removeTransitionLine}>
                    Delete
                  </Button>
                  <Button onClick={onClickFunctionUpdateSM}>Apply</Button>
                </div>
              </div>
            )}

            {isEditModalOpen === "state" && (
              <div>
                <div className="sidebar_top_header">
                  <p>Edit State</p>
                  <MaterialIcon name="close" className="section_close_darkIcon" onClick={onClickFunctionHidePopup} />
                </div>
              </div>
            )}
            {isEditModalOpen === "state" && (
              <div>
                <div className="sm_blueprint_editBox edit_screen_fields">
                  <div className="rightPanel_inside_container g_12">
                    <div className="builder_form">
                      <Input
                        label="State Name"
                        value={selectedItemData.name}
                        onChange={(e) => setSelectedItemData({ ...selectedItemData, name: e.target.value })}
                      />
                    </div>
                    <div className="builder_form g_4" style={{ marginTop: "8px", marginBottom: "20px" }}>
                      <p className="builder_label">State Box Width</p>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <ButtonActionIcon
                          type="remove"
                          onClick={() =>
                            setSelectedItemDataExtraData({
                              ...selectedItemDataExtraData,
                              w: selectedItemDataExtraData.w - 20
                            })
                          }
                        />
                        <span>{selectedItemDataExtraData.w}px</span>
                        <ButtonActionIcon
                          type="add"
                          onClick={() =>
                            setSelectedItemDataExtraData({
                              ...selectedItemDataExtraData,
                              w: selectedItemDataExtraData.w + 20
                            })
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <EditRememberOption
                        activitiesObject={activitiesObject}
                        statesObject={statesObject}
                        setSelectedItemData={setSelectedItemData}
                        selectedItemData={selectedItemData}
                        gatewayObject={gatewayBlock}
                      />
                    </div>
                  </div>
                </div>

                <div className="save_block down" style={{ padding: "0px 20px" }}>
                  {["start", "end"].includes(selectedItemData.type) ? (
                    <div></div>
                  ) : (
                    <Button variant="delete" onClick={handleDelete}>
                      Delete State
                    </Button>
                  )}
                  <Button onClick={onClickFunctionUpdateSM}>Apply</Button>
                </div>
              </div>
            )}

            {isEditModalOpen === "gateway" && (
              <div>
                <div className="sidebar_top_header">
                  <p>Edit Gateway</p>
                  <MaterialIcon name="close" className="section_close_darkIcon" onClick={onClickFunctionHidePopup} />
                </div>
                <EditGatewayOption
                  selectedItemData={selectedItemData}
                  setSelectedItemData={setSelectedItemData}
                  handleDelete={handleDelete}
                  onClickFunctionUpdateSM={onClickFunctionUpdateSM}
                  selectedItemDataExtraData={selectedItemDataExtraData}
                  setSelectedItemDataExtraData={setSelectedItemDataExtraData}
                  statesObject={statesObject}
                  removeTransitionFromGateway={removeTransitionFromGateway}
                  procode={selectedStateMachineBlueprint.pro_code}
                  tableID={selectedStateMachineBlueprint.id}
                />
              </div>
            )}

            {isEditModalOpen === "activity" && (
              <div>
                <div className="sidebar_top_header">
                  <span style={{ fontSize: "14px" }}>Activity: {selectedItemData.name}</span>
                  <MaterialIcon name="close" className="section_close_darkIcon" onClick={onClickFunctionHidePopup} />
                </div>
              </div>
            )}
            {isEditModalOpen === "activity" && (
              <div>
                <div className="sm_blueprint_editBox">
                  <EditActityOption
                    statesObject={statesObject}
                    setSelectedItemData={setSelectedItemData}
                    selectedItemData={selectedItemData}
                    gatewayObject={gatewayBlock}
                  />
                </div>

                <div className="save_block down">
                  {["init"].includes(selectedItemData.type) ? (
                    <div></div>
                  ) : (
                    <Button variant="delete" onClick={handleDelete}>
                      Delete Activity
                    </Button>
                  )}
                  <Button
                    onClick={() => navigate(`../../${appId}/statemachine/${smId}/activity/${selectedItemData?.id}`)}
                  >
                    Edit
                  </Button>
                  <Button onClick={onClickFunctionUpdateSM}>Apply</Button>
                </div>
              </div>
            )}
            {isEditModalOpen === "jobs" && (
              <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <div>
                  <div className="sidebar_top_header">
                    <p>Edit Jobs</p>
                    <MaterialIcon name="close" className="section_close_darkIcon" onClick={onClickFunctionHidePopup} />
                  </div>
                </div>
                <div
                  className="sm_blueprint_editBox"
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    position: "relative"
                  }}
                >
                  <div className="activity_jobs_chain p_3">
                    <div className="activity_select_top_block d_flex flex_column gap_3" style={{ width: "100%" }}>
                      <h2 className="section_sub_heading">Pre Activity Jobs</h2>
                      {activityData.pre_activity_job.length > 0 &&
                        activityData.pre_activity_job.map((job) => (
                          <JobConfigrationCopy
                            key={job.job_id}
                            editJob={job}
                            smId={smId}
                            actId={selectedItemData.id}
                            templateObject={{}}
                            isReadOnly={true}
                            allJobs={allJobs.pre_activity || []}
                            isSmJob={false}
                          />
                        ))}
                    </div>
                    <div className="activity_select_top_block  d_flex flex_column gap_3" style={{ width: "100%" }}>
                      <h2 className="section_sub_heading">Pre Submission Jobs</h2>
                      {activityData.pre_submission.length > 0 &&
                        activityData.pre_submission.map((job) => (
                          <JobConfigrationCopy
                            key={job.job_id}
                            editJob={job}
                            smId={smId}
                            actId={selectedItemData.id}
                            templateObject={{}}
                            isReadOnly={true}
                            allJobs={allJobs.pre_submission || []}
                            isSmJob={false}
                          />
                        ))}
                    </div>

                    <div className="activity_select_top_block  d_flex flex_column gap_3" style={{ width: "100%" }}>
                      <h2 className="section_sub_heading">Post Activity Jobs</h2>
                      {activityData.jobs_trigger.length > 0 &&
                        activityData.jobs_trigger.map((job) => (
                          <JobConfigrationCopy
                            key={job.job_id}
                            editJob={job}
                            smId={smId}
                            actId={selectedItemData.id}
                            templateObject={{}}
                            isReadOnly={true}
                            allJobs={allJobs.post_activity || []}
                            isSmJob={false}
                          />
                        ))}
                    </div>
                  </div>
                </div>
                <div className="save_block down">
                  <Button onClick={() => navigate(`../../${appId}/statemachine/${selectedItemData?.id}`)}>
                    Edit Jobs
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      label: "Global Data",
      content: <SmGlobalData selectedStateMachineBlueprint={selectedStateMachineBlueprint} />
    },
    // {
    //   label: "Related Blocks",
    //   content: <SmAssociatedContent />
    // },
    {
      label: "Pro Code",
      content: <ProCode allProCode={allProCode} setAllProCode={setAllProCode} tableID={smId} />
    },
    {
      label: "Config",
      content: (
        <SmConfig
          smUniqueFields={smUniqueFields}
          setSmUniqueFields={setSmUniqueFields}
          tableID={smId}
          allFieldsObject={allFieldsObject}
        />
      )
    }
  ];

  return (
    <>
      {!isAI && (
        <PageInfoAndActionBar
          pagePath={`SM-Workflow/${selectedStateMachineBlueprint.name}`}
          savePage={saveStateMachineNewBlueprint}
          notesPage={() => setShowNotesModal(!showNotesModal)}
          pageName="statemachine"
          saveTemplate={() => setIsEditModalOpen("template")}
          showSaveTemplate={true}
          settingPage={() => setIsEditModalOpen("setting")}
          currentConfig={[
            selectedStateMachineBlueprint,
            renderFieldsArray,
            renderFieldsData.current,
            allProCode,
            smUniqueFields
          ]}
          // toggleLock={handletoggleLock}
          // isLocked={lockData?.user_id || null}
        />
      )}
      {isAI && <AcceptRejectWorkflow onSave={saveStateMachineNewBlueprint} />}
      <div className="sm_diagramView_outer">
        {isAI ? (
          tabData[0].content
        ) : (
          <BuilderTabs
            tabs={tabData}
            tabsClass={"activity_tab"}
            containerClass="page-action-bar-top align-start"
            onChange={(label) => setSelectedTab(label)}
          />
        )}
        <BuilderRightSideBar
          isOpen={isEditModalOpen === "template"}
          heading="Save Template"
          onClose={() => setIsEditModalOpen(false)}
        >
          <SaveTemplate callback={() => setIsEditModalOpen(false)} />
        </BuilderRightSideBar>

        <BuilderRightSideBar
          isOpen={isEditModalOpen === "setting"}
          heading="SM-Workflow Settings"
          onClose={() => setIsEditModalOpen(false)}
        >
          <StatemachineSetting ownerAssignment={ownerAssignment} setOwnerAssignment={setOwnerAssignment} />
        </BuilderRightSideBar>
      </div>

      <BuilderModal isOpen={modalState.isOpen} onClose={closeModal} modalName={modalState.name}>
        {modalState.type === "add_activity_in_state" ? (
          <AddActivityInStateModal
            onCreate={cteateNewItemInStateMachine}
            smConfig={selectedStateMachineBlueprint}
            stateId={modalState.stateId}
          />
        ) : modalState.type === "show_form_preview" ? (
          <FormFieldPreview smConfig={selectedStateMachineBlueprint} actId={modalState.actId} />
        ) : modalState.type === "gateway" ? (
          <CreateGatewayModal createFunction={cteateNewItemInStateMachine} />
        ) : (
          <CreateStateModal createFunction={cteateNewItemInStateMachine} />
        )}
      </BuilderModal>
      <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Add Notes">
        <NotesAndTags notesValue={selectedStateMachineBlueprint?.description || ""} onChange={handleNotesAndTag} />
      </BuilderModal>
    </>
  );
};

export default StateBlueprintRenderer;

const FormFieldPreview = ({ smConfig, actId }) => {
  if (!smConfig || !smConfig.activities) {
    return <p style={{ color: "red" }}>Error: Invalid configuration data</p>;
  }

  const selectedAct = smConfig.activities.find((act) => act.id === actId);

  if (!selectedAct) {
    return <p style={{ color: "red" }}>Error: Activity not found</p>;
  }

  const allFields = selectedAct?.form?.sections?.[0]?.fields || [];

  if (allFields.length === 0) {
    return <p>No fields available</p>;
  }

  return (
    <div style={{ background: "#f1f3f4" }}>
      <div className="stateMachine_form_container">
        {allFields.map((field) => {
          const { ...fieldWithoutKey } = field;
          return (
            <div key={field.id} className={`single_field_render`}>
              <MaterialIcon name={getFieldIcon(field.type)} style={{ color: "#667085", marginRight: "8px" }} />
              <div className="form_element_container">
                <FieldTag key={field.id} element={fieldWithoutKey} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const SmConfig = ({ smUniqueFields, setSmUniqueFields, tableID, allFieldsObject }) => {
  const [isUniqueOpen, setIsUniqueOpen] = useState(false);

  const selectUniqueFields = (data) => {
    const copyUniqueFields = JSON.parse(JSON.stringify(smUniqueFields));
    if (copyUniqueFields.includes(data.id)) {
      toastError("Duplicate fields not allowed");
      return;
    }
    copyUniqueFields.push(data.id);
    setSmUniqueFields(copyUniqueFields);
  };
  const removeUniqueField = (id) => {
    const copyUniqueFields = JSON.parse(JSON.stringify(smUniqueFields));
    const updatedFields = copyUniqueFields.filter((field) => field !== id);
    setSmUniqueFields(updatedFields);
  };
  return (
    <div className="kanban_main_page">
      <div className="activity_select_top_block builder_form" style={{ margin: "82px 24px", width: "500px" }}>
        <div style={{ display: "flex", gap: "8px" }}>
          <label className="builder_label">Select unique fields </label>
          <ButtonActionIcon type="add" size="xsm" onClick={() => setIsUniqueOpen(true)} />
        </div>
        <div className="selected_chip_container" style={{ margin: "8px 0px 20px 0px" }}>
          {smUniqueFields?.map((field) => (
            <div key={field.id} className="selected_chip_items" style={{ padding: "4px 8px" }}>
              {allFieldsObject.current[field]?.display}
              <MaterialIcon name="close" onClick={() => removeUniqueField(field)} style={{ fontSize: "16px" }} />
            </div>
          ))}
        </div>
      </div>
      <BuilderModal isOpen={isUniqueOpen} onClose={() => setIsUniqueOpen(false)} modalName="Select Unique Fields">
        <TableTreeModal callbackFunction={selectUniqueFields} tableId={tableID} />
      </BuilderModal>
    </div>
  );
};

const StatemachineSetting = ({ ownerAssignment, setOwnerAssignment }) => {
  const [selectedTab, setSelectedTab] = useState("owner");
  const [isFieldModalOpen, setIsFieldModalOpen] = useState(false);
  const [tableData, setTableData] = useState({});
  const { getTableTypeData } = useTableContext();
  const { selectedStateMachineBlueprint, setSelectedStateMachineBlueprint } = useStatemachineContext();

  const handleOnchange = (e) => {
    const value = e.target.value;

    setSelectedStateMachineBlueprint({
      ...selectedStateMachineBlueprint,
      ticket_config: { ...selectedStateMachineBlueprint.ticket_config, support_email: value }
    });
  };

  const handleEmailField = (data) => {
    setSelectedStateMachineBlueprint({
      ...selectedStateMachineBlueprint,
      ticket_config: { ...selectedStateMachineBlueprint.ticket_config, mapped_email_field: data.id }
    });
    setIsFieldModalOpen(false);
  };
  const fetchTableData = async () => {
    try {
      const { tableObject } = await getTableTypeData("statemachine", selectedStateMachineBlueprint.id);
      setTableData(tableObject);
    } catch (error) {
      toastError(error.message);
    }
  };
  useEffect(() => {
    fetchTableData();
  }, []);

  return (
    <>
      <div className="sidebar_tab_buttons">
        {["owner", "general"].map((tab) => (
          <div
            key={tab}
            className={`sidebar_tabs ${selectedTab === tab ? "active" : ""}`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      {selectedTab === "owner" && (
        <OwnerAssignment ownerAssignment={ownerAssignment} setOwnerAssignment={setOwnerAssignment} />
      )}
      {selectedTab === "general" && (
        <div className="edit_activity_owner_group builder_form">
          <Input
            label="Enter Your Support Email"
            type="email"
            value={selectedStateMachineBlueprint.ticket_config.support_email}
            onChange={handleOnchange}
            placeholder="Enter Email"
          />
          <label className="builder_label">Select Email Field</label>
          <div className="builder_displayBox" onClick={() => setIsFieldModalOpen(true)}>
            {tableData[selectedStateMachineBlueprint.ticket_config.mapped_email_field]?.display || "select mail field"}
          </div>
        </div>
      )}
      {isFieldModalOpen && (
        <BuilderModal
          isOpen={isFieldModalOpen}
          onClose={() => setIsFieldModalOpen(false)}
          modalName={`Select Email Field`}
        >
          <TableTreeModal callbackFunction={handleEmailField} tableId={selectedStateMachineBlueprint.id} />
        </BuilderModal>
      )}
    </>
  );
};

const CreateGatewayModal = ({ createFunction }) => {
  const [name, setName] = useState("");

  return (
    <div className="builder_form">
      <Input
        label="Gateway Name"
        placeholder="Enter Gateway name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Button onClick={() => createFunction(name)}>Create Gateway</Button>
    </div>
  );
};

const CreateStateModal = ({ createFunction }) => {
  const [name, setName] = useState("");

  return (
    <div className="builder_form">
      <div className="builder_form">
        <Input
          label={` name`}
          placeholder={`Enter name`}
          name="firstName"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <Button onClick={() => createFunction(name)}>Create</Button>
    </div>
  );
};

const AddActivityInStateModal = ({ smConfig, stateId, onCreate }) => {
  const [formData, setFormData] = useState({
    activities: [],
    activitiesNames: []
  });

  const handleChangeActivitiesName = (newActivities) => {
    setFormData((prev) => ({ ...prev, activitiesNames: newActivities }));
  };

  const handleOnchange = (selectedActivities) => {
    setFormData((prev) => ({ ...prev, activities: selectedActivities }));
  };

  useEffect(() => {
    if (!smConfig) return;

    const { result } = mapArrayToObject(smConfig.activities);
    const state = smConfig.states.find((state) => state.id === stateId);
    if (!state) return;

    let allowActivities = [];
    (state.remember?.allow_activities || []).forEach((activityId) => {
      const activity = result[activityId];
      if (activity) {
        allowActivities.push(activity);
      }
    });

    setFormData((prev) => ({ ...prev, activities: allowActivities }));
  }, [smConfig, stateId]);

  const handleSubmit = () => {
    onCreate(formData);
  };

  return (
    <div className="builder_form" style={{ maxWidth: "25vw" }}>
      <ChipsInput
        inputArray={formData.activitiesNames}
        label="Add new Activities"
        onChange={handleChangeActivitiesName}
      />
      <MultiSelectBox
        label="Select From Existing"
        options={smConfig.activities}
        selectedData={formData.activities}
        onChange={handleOnchange}
      />
      <Button onClick={handleSubmit}>Update</Button>
    </div>
  );
};

const SmGlobalData = ({ selectedStateMachineBlueprint }) => {
  const [dragFromOutside, setDragFromOutside] = useState(false);

  const handleDragStart = useCallback(
    (e, name) => {
      e.dataTransfer.setData("type", name);
      setDragFromOutside(true);
    },
    [setDragFromOutside]
  );

  const memoizedRightSideFieldsBar = useMemo(() => {
    return <RightSideFieldsBar from="sm" handleDragStart={handleDragStart} />;
  }, [handleDragStart]);

  return (
    <div>
      {/* <FormSection from="sm" /> */}
      <div className="form_outer_section">
        <FormLayoutWithEdit
          dragFromOutside={dragFromOutside}
          setDragFromOutside={setDragFromOutside}
          isDesktopModeOpen={false}
          from="sm"
          tableID={selectedStateMachineBlueprint.id}
        />
        <div className="rightsidebar">{memoizedRightSideFieldsBar}</div>
      </div>
    </div>
  );
};

const AcceptRejectWorkflow = ({ onSave }) => {
  const { orgId, appId, smId } = useParams();
  const navigate = useNavigate();
  const { setStateMachineExplorerData, setFormsExplorerData } = useTreeContext();

  const handleBack = () => {
    navigate(`/organization/${orgId}/app/${appId}/statemachine/${smId}`);
  };

  const handleSave = async () => {
    try {
      await onSave(true);

      setStateMachineExplorerData(null);
      setFormsExplorerData(null);

      handleBack();
    } catch (error) {
      console.error("Error saving state machine", error);
    }
  };

  return (
    <div className="d_flex gap_3 px_4 py_3 justify_end">
      <Button variant="secondary" className="border_radius_small" onClick={handleBack}>
        Cancel
      </Button>
      <Button className="border_radius_small" onClick={handleSave}>
        Accept
      </Button>
    </div>
  );
};

const DownloadFieldsDetails = ({ smId }) => {
  const downloadFieldsDetails = async () => {
    try {
      const res = await axiosInstance.get(`/state-machine/${smId}`);
      const config = res.data.config;

      // === 1. Global Fields ===
      const globalFields = config.global_data_form?.fields || [];
      const filteredGlobalFields = globalFields.map(({ id, label, type }) => ({
        id,
        label,
        type
      }));

      // Build lookup for global fields: { id: label }
      const globalFieldMap = {};
      globalFields.forEach(({ id, label }) => {
        globalFieldMap[id] = label;
      });

      downloadJSONFile(filteredGlobalFields, `${config.name}_global_fields.json`);

      // === 2. Activities Fields with global_data_info enrichment ===
      const activityFieldsStructured = (config.activities || []).map((activity) => {
        const fields = (activity.form?.sections?.[0]?.fields || []).map((field) => {
          const { id, label, type } = field;
          const result = { id, label, type };

          if (type === "global-data" && field.global_field?.id) {
            const globalId = field.global_field.id;
            result.global_data_info = {
              id: globalId,
              label: globalFieldMap[globalId] || "(Unknown Global Field)"
            };
          }

          return result;
        });

        return {
          name: activity.name,
          fields
        };
      });

      downloadJSONFile(activityFieldsStructured, `${config.name}_activity_fields.json`);
    } catch (e) {
      handleApiError(e);
    }
  };

  const downloadJSONFile = (data, fileName) => {
    const jsonBlob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json"
    });

    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(jsonBlob);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <MaterialIcon name="download" title="Download Fields" style={{ display: "none" }} onClick={downloadFieldsDetails} />
  );
};
